(function (global) {
  const preferenceKey = 'demoResetShortcutBusinessIds';
  const membershipFor = (memberships, businessId) => (Array.isArray(memberships) ? memberships : [])
    .find((membership) => (membership.businessId || membership.id) === businessId);

  const isAvailable = ({ demoAccount, memberships, businessId } = {}) => {
    const membership = membershipFor(memberships, businessId);
    return demoAccount === true && ['owner', 'admin'].includes(membership?.role);
  };

  const isEnabled = ({ preferences, businessId } = {}) =>
    preferences?.[preferenceKey]?.[String(businessId || '')] === true;

  const preferencePatch = (preferences, businessId, enabled) => ({
    [preferenceKey]: {
      ...(preferences?.[preferenceKey] || {}),
      [String(businessId || '')]: enabled === true,
    },
  });

  global.PlummeDemoResetShortcut = { preferenceKey, isAvailable, isEnabled, preferencePatch };
})(window);
